import React from 'react';
import gamingPc from '../../images/most-searched/gamingpc.png';
import miniPc from '../../images/most-searched/minipc.png';
import officePc from '../../images/most-searched/officepc.png';
import monitor from '../../images/most-searched/monitor.png';

const MostSearchedCategories: React.FC = () => {
  return (
    <div style={{ 
      backgroundColor: '#f8f8f8', 
      padding: '40px 20px', 
      textAlign: 'center' 
    }}>
      <h2 className='text-2xl' style={{ marginBottom: '10px' }}>Most searched categories</h2>
      <a href="#" style={{ color: '#007bff', fontSize: '0.9em', marginBottom: '30px', display: 'block' }}>View more &gt;</a> 
      <div
        className='container mx-auto' 
        style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          flexWrap: 'wrap', 
          gap: '20px' 
        }}
      >
        <CategoryItem 
          title="Office Case" 
          image={officePc} 
        />
        <CategoryItem 
          title="Monitors" 
          image={monitor} 
        />
        <CategoryItem 
          title="Gaming Case" 
          image={gamingPc} 
        />
        <CategoryItem 
          title="MiniPC" 
          image={miniPc} 
        />
      </div>
    </div>
  );
};

interface CategoryItemProps {
  title: string;
  image: string;
}

const CategoryItem: React.FC<CategoryItemProps> = ({ title, image }) => {
  return (
    <div className='w-[calc(50%-15px)] md:w-[calc(25%-15px)]' style={{ 
      backgroundColor: 'white', 
      borderRadius: '8px', 
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', 
      padding: '20px', 
      position: 'relative',
      marginTop: '30px',
      cursor: 'pointer'
    }}>
      <div style={{ 
        position: 'absolute', 
        top: '-30px', 
        left: '50%', 
        transform: 'translateX(-50%)', 
        width: '150px', 
        height: '150px' 
      }}>
        <img src={image} alt={title} style={{ maxWidth: '100%', maxHeight: '100%' }} />
      </div>
      <div style={{ paddingTop: '120px' }}>
        <h3 style={{ margin: 0, fontSize: '1.2em', fontWeight: '400', textWrap: 'nowrap' }}>{title}</h3>
      </div>
    </div>
  );
};

export default MostSearchedCategories;